import { SxProps, Theme } from '@mui/material';

/**
 * Hides an element visually while leaving it in the accessibility tree.
 *
 * Sizes are explicit strings: `sx` reads a bare `1` as `100%` and `-1` as `-8px`.
 */
export const visuallyHiddenSx: SxProps<Theme> = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};
